define('Inspiredspace.ei1.Main.View', [
    'PageType.Base.View',
    'inspired_space.tpl',
    'Inspiredspace.ei1.Main.Model'
], function (
    PageTypeBaseView,
    inspired_space_tpl,
    InspiredspaceModel
) {
    'use strict';

    var SITE_DOMAIN = 'https://1homeoffice.com';

    function findCategoryByName(categories, name) {
        for (var i = 0; i < categories.length; i++) {
            if (categories[i].name && categories[i].name.trim().toLowerCase() === name.toLowerCase()) {
                return categories[i];
            }
            if (categories[i].subCategories && categories[i].subCategories.length) {
                var found = findCategoryByName(categories[i].subCategories, name);
                if (found) return found;
            }
        }
        return null;
    }

    function cleanName(name) {
        if (!name) return '';
        return name.replace(/\s*(room|alcove)\s*$/i, '').trim();
    }

    function buildImageUrl(path) {
        if (!path) return '';
        if (path.indexOf('http') === 0) return path;
        return SITE_DOMAIN + path;
    }

    function getSlug(name) {
        var cleaned = cleanName(name).toLowerCase().trim();
        return cleaned.split(/\s+/)[0] || '';
    }
    function sortBySequence(categories) {
        return (categories || []).slice().sort(function (a, b) {
            var seqA = (a.sequenceNumber === undefined || a.sequenceNumber === null) ? Infinity : Number(a.sequenceNumber);
            var seqB = (b.sequenceNumber === undefined || b.sequenceNumber === null) ? Infinity : Number(b.sequenceNumber);
            return seqA - seqB;
        });
    }

    return PageTypeBaseView.PageTypeBaseView.extend({
        template: inspired_space_tpl,


        showContent: function () {
            var self = this;
            // Call the BASE class's showContent, not the layout directly
            var result = PageTypeBaseView.PageTypeBaseView.prototype.showContent.apply(this, arguments);

            if (result && typeof result.done === 'function') {
                result.done(function () {
                    self.scrollToSection();
                });
            } else {
                // In case base showContent doesn't return a deferred
                self.scrollToSection();
            }

            return result;
        },

        scrollToSection: function () {
            var urlParams = new URLSearchParams(window.location.search);
            var targetId = urlParams.get('scrollto');
            if (targetId) {
                var $targetElement = jQuery('#' + targetId);
                if ($targetElement.length) {
                    jQuery('html, body').animate({
                        scrollTop: $targetElement.offset().top - 100
                    }, 800);
                }
            }
        },

        initialize: function initialize() {
            this.model = new InspiredspaceModel();
        },

        beforeShowContent: function beforeShowContent() {
            return this.model.fetch();
        },

        getContext: function getContext() {
            var response = this.model.toJSON();
            var tree = (response && response.data) ? response.data : [];

            var meetingRoomCat = findCategoryByName(tree, 'Meeting Room');
            var meetingRooms = sortBySequence(meetingRoomCat ? (meetingRoomCat.subCategories || []) : []);

            var alcovesCat = findCategoryByName(tree, 'Alcoves');
            var alcoves = sortBySequence(alcovesCat ? (alcovesCat.subCategories || []) : []);

            var workstations = findCategoryByName(tree, 'Workstations');

            var workstationCard = workstations ? {
                name: cleanName(workstations.name),
                description: workstations.description,
                image: buildImageUrl(workstations.pageBanner)
            } : null;





            var meetingRoomCards = meetingRooms.map(function (room) {
                return {
                    name: cleanName(room.name),
                    image: buildImageUrl(room.roomImage),
                    url: '/room/' + getSlug(room.name),
                    tourUrl: room.tourUrl || ''   // ← NEW
                };
            });

            var alcoveCards = alcoves.map(function (alcove) {
                return {
                    name: cleanName(alcove.name),
                    image: buildImageUrl(alcove.thumbnail),
                    url: '/room/' + getSlug(alcove.name),
                    tourUrl: alcove.tourUrl || ''   // ← NEW
                };
            });

            console.log('=== Inspired Space Categories ===');
            console.log('Meeting Rooms (' + meetingRooms.length + '):');
            meetingRooms.forEach(function (room) {
                console.log('  -', cleanName(room.name), '| id:', room.id);
            });
            console.log('Alcoves (' + alcoves.length + '):');
            alcoves.forEach(function (alcove) {
                console.log('  -', cleanName(alcove.name), '| id:', alcove.id);
            });
            console.log('Workstations:');
            if (workstations) {
                console.log('  -', workstations.name, '| id:', workstations.id);
            } else {
                console.log('  - Not found');
            }

            return {
                meetingRoomCards: meetingRoomCards,
                alcoveCards: alcoveCards,
                workstation: workstationCard
            };
        }
    });
});
